import React from "react";
import SectionLayout from "../SectionLayout";
import { HiChevronRight } from "react-icons/hi";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const JenjangItem = ({ title, link, color }) => {
  return (
    <Link
      to={link}
      target="_blank"
      rel="noopener noreferrer"
      className={`flex items-center justify-between p-4 rounded-xl border border-neutral-200 dark:border-neutral-700 hover:shadow-lg transition-all duration-300 group bg-white dark:bg-neutral-800`}
    >
      <div className="flex items-center gap-4">
        <div className={`w-2 h-10 rounded-full ${color}`}></div>
        <span className="text-base-semibold text-neutral-800 dark:text-neutral-200 uppercase tracking-wide">
          {title}
        </span>
      </div>
      <HiChevronRight className="w-6 h-6 text-neutral-400 group-hover:text-idi-800 group-hover:translate-x-1 transition-all" />
    </Link>
  );
};

const JenjangSection = () => {
  const { t } = useTranslation();

  const menuJenjang = [
    {
      title: t("nav.mts"),
      link: "https://mts.idrisiyyah.sch.id",
      color: "bg-idi-800",
    },
    {
      title: t("nav.ma"),
      link: "https://ma.idrisiyyah.sch.id",
      color: "bg-idi-800",
    },
    {
      title: t("nav.smk"),
      link: "https://smk.idrisiyyah.sch.id",
      color: "bg-idi-800",
    },
  ];

  return (
    <SectionLayout title={"Unit Lembaga"} classname="w-full xl:w-5/12">
      <div className="flex flex-col gap-4 mt-2">
        {menuJenjang.map((item, index) => (
          <JenjangItem key={index} {...item} />
        ))}
      </div>
    </SectionLayout>
  );
};

export default JenjangSection;
